export default __webpack_public_path__ + "static/media/nonRattacher.9b858c77.png";